var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.894 5.604-8.936 4.874a2 2 0 0 1-1.916 0L1.107 5.604m19.787 0a1.833 1.833 0 0 0-1.644-1.02H2.75c-.72 0-1.344.415-1.643 1.02m19.787 0c.121.245.19.52.19.813v9.166c0 1.013-.821 1.834-1.834 1.834H2.75a1.833 1.833 0 0 1-1.833-1.834V6.418c0-.292.068-.568.19-.813",
    stroke: "#777E91",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgEnvelope;